import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import type { TAppDispatch, TRootState } from '.';

export const createAppAsyncThunk = createAsyncThunk.withTypes<{
  state: TRootState;
  dispatch: TAppDispatch;
}>();

export type TMetaAsyncThunk = ReturnType<
  | AsyncThunk<unknown, unknown, object>['pending']
  | AsyncThunk<unknown, unknown, object>['fulfilled']
  | AsyncThunk<unknown, unknown, object>['rejected']
>['meta'];
